<template>
  <multiple_form
    :forms="forms"
    :edit="false"
    :submitBtn="false"
    :editData="props.editData"
    :disabled="true"

  />
</template>
<script setup>
  import { ref, defineProps, defineEmits, computed, toRefs } from 'vue'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/car_application/enterprise_application'
  import multiple_form from '@/components/multiple_form'
  import {
    gender,
    cargoType,
    yesOrNot,
    strandedLevel,
    strandedSmsStatus,
    strandedFalseAlarm,
  } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import { useStore } from 'vuex'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    canEdit: {
      default: true,
    },
    editData: Object,
    data: Array,
    idField: String,
    disabled: Boolean,
  })
  const emit = defineEmits(['submit', 'error', 'change'])
  const showDanger = ref(props.editData?.cargo_type == '1')
  const store = useStore()
  const { carModelObj } = toRefs(store.state?.common)
  const showCargo = ref(
    !!carModelObj.value[props?.editData?.vehicle_type_id]?.show_cargo_type
  )
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '告警信息',
      id: 'warm',
      formItem: [
        {
          type: 'select',
          field: 'level_type',
          options: constantToOptions(strandedLevel),
          label: '等级',
        },
        {
          type: 'input',
          field: 'alarm_time',
          label: '告警时间',
        },
        {
          type: 'select',
          field: 'handle_user_id',
          label: '处理人',
          storeOptions: 'user',
        },
        {
          type: 'input',
          field: 'handled_remark',
          label: '处理结果描述',
        },
        {
          type: 'select',
          field: 'false_alarm',
          label: '是否误报',
          options: constantToOptions(strandedFalseAlarm),
        },
        {
          type: 'select',
          field: 'is_black',
          label: '加入黑名单',
          options: constantToOptions(yesOrNot),
        },
        {
          type: 'input',
          field: 'phones',
          label: '接收短信手机号',
        },
        {
          type: 'select',
          field: 'sms_send',
          label: '短信发送状态',
          options: constantToOptions(strandedSmsStatus),
        },
        {
          type: 'input',
          field: 'sms_error_response',
          label: '发送失败响应',
        },
        {
          type: 'input',
          field: 'sms_content',
          label: '短信内容',
          width: '80vw',
        },
      ],
    },
    {
      name: '申请人信息',
      id: 'applicant_information',
      dataInObject: 'application_info',
      formItem: [
        {
          type: 'input',
          field: 'applicant_name',
          label: '姓名',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'applicant_idcard',
          label: '证件号码',
        },
        {
          type: 'select',
          field: 'applicant_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'applicant_phone',
          label: '联系电话',
        },
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
      ],
    },
    {
      name: '车辆信息',
      id: 'vehicle_information',
      dataInObject: 'application_info',
      formItem: [
        {
          type: 'select',
          field: 'vehicle_type_id',
          label: '车型(行驶证)',
          storeOptions: 'carModel',
          onChange: (e) => {
            showCargo.value = !!carModelObj.value[e]?.show_cargo_type
          },
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
        },
        {
          type: 'select',
          field: 'color_id',
          label: '车辆颜色',
          storeOptions: 'vehicleColorType',
        },
        {
          type: 'input',
          field: 'vehicle_license_number',
          label: '车辆识别代号',
        },
        /*{
          type: 'input',
          field: 'engine_number',
          label: '发动机号码',
        },*/
        {
          type: 'radio',
          field: 'cargo_type',
          options: constantToOptions(cargoType),
          label: '货物类型',
          hidden: !showCargo.value,
          onChange: cargoTypeChange,
        },
        {
          type: 'input',
          field: 'cargo_name',
          label: '货物名称',
          hidden: !showCargo.value,
        },
        {
          type: 'input',
          field: 'car_load',
          label: '载重(吨)',
          hidden: !showCargo.value,
        },
        {
          type: 'input',
          field: 'remark',
          label: '备注',
        },
        {
          type: 'imgUpload',
          field: 'vehicle_img',
          label: '车辆照片',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visiting_information',
      dataInObject: 'application_info',
      formItem: [
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          storeOptions: 'areaType',
        },
        {
          type: 'radio',
          storeOptions: 'carVisitType',
          field: 'visitor_type',
          label: '申请类型',
          tips: [
            '施工车辆访问时间不能超过三个月，通行时间段为9:00-18:00！ ',
            '维修车辆访问时间不能超过一个月，通行时间段为9:00-18:00！',
            '临时车辆访问时间不能超过三天，通行时间段为9:00-18:00！',
            '业主车辆访问时间不能超过一年',
          ],
        },
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          label: '被访问机构',
          storeOptions: 'dept',
        },
        {
          type: 'input',
          field: 'visitor_content',
          label: '来访事由',
        },
        {
          type: 'dateRange',
          startField: 'visitor_begin_time',
          endField: 'visitor_end_time',
          label: '来访时间',
          disabledDate(current, dayjs) {
            return current < dayjs().add(2, 'day').endOf('day')
          },
        },
      ],
    },
  ])

  function cargoTypeChange(data) {
    if (data.target.value === '1') showDanger.value = true
    else showDanger.value = false
  }

  //提交
  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const filteredData = filterData(data, !showCargo.value, [
      'car_load',
      'cargo_name',
      'cargo_type',
      'cargo_info',
    ])
    const res = await ajaxFn({ ...filteredData, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }

  function filterData(data, doFilter, fields) {
    let newData = JSON.parse(JSON.stringify(data))
    if (doFilter) {
      fields.forEach((item) => delete newData[item])
      return newData
    }
    return data
  }
</script>
